import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductBumnanSmart } from 'quick-quote/product-bumnan-ready/actions'
import { getAvaliableProductBumnanSmart, getActiveProductCodeBumnanSmart } from '../selectors'
import VALUES from 'core/data-model/constants/values'

export const BumnanSmartProductSelection = ({
  getAvaliableProductBumnanSmart,
  getActiveProductCodeBumnanSmart,
  selectProductBumnanSmart,
}) => {
  const avaliableProductCodeBumnanSmart = getAvaliableProductBumnanSmart.map((product) => product.code)
  const productBumnanSmart = [
    {
      text: '6 ปี',
      value: VALUES.BUMNAN_SMART_DEFAULT_CODE.BUMNAN_SMART_6,
      canSelectable: VALUES.BUMNAN_SMART_GROUP_CODE.BUMNAN_SMART_6.some((code) =>
        avaliableProductCodeBumnanSmart.includes(code)
      ),
    },
    {
      text: 'ตลอดจนรับเงินบำนาญ',
      value: VALUES.BUMNAN_SMART_DEFAULT_CODE.BUMNAN_SMART_AGE,
      canSelectable: VALUES.BUMNAN_SMART_GROUP_CODE.BUMNAN_SMART_AGE.some((code) =>
        avaliableProductCodeBumnanSmart.includes(code)
      ),
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductBumnanSmart}
        value={getActiveProductCodeBumnanSmart}
        options={productBumnanSmart}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getAvaliableProductBumnanSmart: getAvaliableProductBumnanSmart(state),
  getActiveProductCodeBumnanSmart: getActiveProductCodeBumnanSmart(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductBumnanSmart: bindActionCreators(selectProductBumnanSmart, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(BumnanSmartProductSelection)
